import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material'
import { ApiError } from '../api/errors'
import { t } from '../i18n'

/**
 * ADR-0024 D9.3 - padrao unico de erro.
 *
 * Exibe sempre o `X-Request-ID` da resposta: com ele, qualquer relato de
 * usuario e rastreavel ate o trace no Application Insights e ate o evento de
 * auditoria correspondente (ADR-0023 D9).
 */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const apiError = error instanceof ApiError ? error : null
  const message = apiError?.isNetworkError
    ? t.error.networkMessage
    : t.error.genericMessage

  return (
    <Alert severity="error" sx={{ my: 2 }}>
      <AlertTitle>{t.error.title}</AlertTitle>
      <Typography variant="body2">{message}</Typography>
      {apiError?.requestId && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="caption" color="text.secondary" display="block">
            {t.error.requestIdHint}
          </Typography>
          <Typography variant="caption" component="code" sx={{ fontFamily: 'monospace' }}>
            {apiError.requestId}
          </Typography>
        </Box>
      )}
      {onRetry && (
        <Box sx={{ mt: 2 }}>
          <Button size="small" variant="outlined" color="inherit" onClick={onRetry}>
            {t.common.retry}
          </Button>
        </Box>
      )}
    </Alert>
  )
}
